module.exports = __webpack_public_path__ + "static/img/Rotatedevice.c1e53099.png";